import { Component, ViewEncapsulation } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { v_DispatchPartsRequestedBus } from '@app/cp/shared/models/v_DispatchPartsRequestedBus';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';

@Component({
  selector: 'job-parts-requested',
  templateUrl: './job-parts-requested.component.html',
  styleUrls: ['./job-parts-requested.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class JobPartsRequestedComponent extends BaseGridUIComponent<v_DispatchPartsRequestedBus, null, DispatchesService>  {

  constructor(globals: GlobalsService, svc_data: DispatchesService) {
    super(globals);
    this.svc_data = svc_data;
  }
}
